<template>
  <div class="tabs-wrap">
    <div class="tabs-content">
      <div class="tabs-content-left">
        <div class="rewardHistory btn-small flex-center btn" :class="{ active: tabActive === 'rewardHistory' }" @click="showHistory">
          {{ $t("wc2026.tabs.rewardHistory") }}
        </div>
        <div class="goEarn btn-large  flex-center btn" :class="{ active: tabActive === 'rank' }" @click="changeTab('rank')">
          {{ $t("wc2026.tabs.cheerPowCash") }}
        </div>
      </div>
      <div class="cheer-count-wrap flex-center">
        <div>
        <div class="count">
         {{ activityInfo.availableCheerCount }}
        </div>
        <div class="label">
          {{ $t("wc2026.tabs.cheerCountLabel") }}
        </div>
        </div>
      </div>
      <div class="tabs-content-right">
        <div class="toCheer btn-small flex-center btn" :class="{ active: tabActive === 'goEarn' }" @click="showTask">
          {{ $t("wc2026.tabs.goEarn") }}
        </div>
        <div class="toCheer btn-large flex-center btn" :class="{ active: tabActive === 'toCheer' }" @click="changeTab('toCheer')">
          {{ $t("wc2026.tabs.toCheer") }}
        </div>
      </div>
    </div>
    <div class="bottom-wrap"></div>
    <LoginDialog
    v-model="state.showLoginDialog"
    @loginSuccess="onLoginSuccess"
    />
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, computed, reactive } from 'vue'
import { useStore } from 'vuex'
import LoginDialog from '../LoginDialog/index.vue'

const store = useStore()
const activityInfo = computed(() => store.state.wcAct.activityInfo || {})
const actUserInfo = computed(() => store.state.actUserInfo || {})



const props = defineProps({
  modelValue: {
    type: String,
    default: 'toCheer',
  },
})
const emit = defineEmits(['update:modelValue', 'showHistory', 'showTask'])
const tabActive = ref(props.modelValue)

const state = reactive({
  showLoginDialog: false,
})
const changeTab = (val) => {
  if(!actUserInfo.value.token) {
    state.showLoginDialog = true
    return
  }
  tabActive.value = val
}
const showHistory = () => {
  if(!actUserInfo.value.token) {
    state.showLoginDialog = true
    return
  }
  emit('showHistory')
}
const showTask = () => {
  if(!actUserInfo.value.token) {
    state.showLoginDialog = true
    return
  }
  emit('showTask')
}
watch(() => tabActive.value, (newVal) => {
  emit('update:modelValue', newVal)
}, {
  immediate: true
})
</script>

<style lang="less" scoped>
.tabs-wrap {
  font-weight: bold;
  padding-top: 22px;
  padding-bottom: 54px;
  .tabs-content {
    display: flex;
    /* padding: 0 30px; */
    justify-content: space-between;
    margin-bottom: 54px;
    .tabs-content-left,.tabs-content-right {
      padding-top: 35px;
      .btn-small {
        margin: auto;
        margin-bottom: 20px;
        width: 176px;
        height: 64px;

        background-image:url("~@/assets/imgs/act/wc2026/tabs/btn-small.png");

        &.active {
          background-image:url("~@/assets/imgs/act/wc2026/tabs/btn-small-active.png");
        }

      }
      .btn-large {
        width: 255px;
        height: 89px;
        margin: auto;
        background-image:url("~@/assets/imgs/act/wc2026/tabs/btn-large.png");
        &.active {
          background-image:url("~@/assets/imgs/act/wc2026/tabs/btn-large-active.png");
        }
      }
    }
    .cheer-count-wrap {
      width: 225.6px;
      height: 184.8px;
      flex-shrink: 0;
      text-align: center;
      flex-wrap: wrap;
      background-image:url("~@/assets/imgs/act/wc2026/tabs/center-bg.png");
      .count {
        font-size: 35px;
        color: #DD471F;
        font-weight: bold;
        margin-bottom: 15px;
        width: 100%;
        text-align: center;
      }
      .label {
        font-size: 17px;
        color: #1B0926;
      }
    }

  }

}
</style>
